export default "__VITE_ASSET__biYNTn0l__"